import { render, staticRenderFns } from "./PhotoCards.vue?vue&type=template&id=40d99693&"
import script from "./PhotoCards.vue?vue&type=script&lang=js&"
export * from "./PhotoCards.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports